import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { closeSnackbar, enqueueSnackbar } from "notistack";
import { ReactComponent as CloseIcon } from "../../../assets/icons/portfolio/login-cross.svg";
import Button from "../../../components/button/Button";
import Header from "../../../components/header/Header";
import axios from "axios";
import "./WithdrawBank.css";

const WithdrawBank = () => {
  (function () {
    function decimalAdjust(type, value, exp) {
      if (typeof exp === "undefined" || +exp === 0) {
        return Math[type](value);
      }
      value = +value;
      exp = +exp;
      if (isNaN(value) || !(typeof exp === "number" && exp % 1 === 0)) {
        return NaN;
      }
      value = value.toString().split("e");
      value = Math[type](
        +(value[0] + "e" + (value[1] ? +value[1] - exp : -exp))
      );
      value = value.toString().split("e");
      return +(value[0] + "e" + (value[1] ? +value[1] + exp : exp));
    }

    if (!Math.floor10) {
      Math.floor10 = function (value, exp) {
        return decimalAdjust("floor", value, exp);
      };
    }
  })();

  const { t } = useTranslation();

  const token = localStorage.getItem("token");
  const [hdnpp, setHdnpp] = useState(true);

  const [bankTransferAmount, setBankTransferAmount] = useState("");
  const [bankTransferVar, setBankTransferVar] = useState("Other");
  const [bankTransferVar2, setBankTransferVar2] = useState("");
  const [cryptoTransferVar, setCryptoTransferVar] = useState("");
  const [cryptoWallet, setCryptoWallet] = useState("");
  const [ownerName, setOwnerName] = useState("");
  const [sbpp, setsbpp] = useState("");
  const [bankName, setBankName] = useState("");
  const [cardNumber, setCardNumber] = useState("");
  const [portfolioActive, setPortfolioActive] = useState(true);
  const [cursCb, setCursCb] = useState(90);
  const [idbk, setIdbk] = useState();
  const [idcr, setIdcr] = useState();

  const action = (snackbarId) => (
    <button className="close-button" onClick={() => { closeSnackbar(snackbarId) }}>
        <CloseIcon/>
    </button>
  );

  const getUserPortfolioData = () => {
    axios
      .get("https://api-ru.fynex.cc/api/api/user/portfolio", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setPortfolioActive(res.data.withdrawDeny);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const cbc = () => {
    axios
      .get(`https://api-ru.fynex.cc/api/api/current_coin/ruble`)
      .then((res) => {
        setCursCb(res.data);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  useEffect(() => {
    cbc();
    getUserPortfolioData();
  }, []);

  const handleBankPayment = () => {
    if (bankTransferVar == "") {
      enqueueSnackbar(t("WithdrawBank.errCard"), {
        action,
        variant: "error",
        className: "snackerror",
      });
    } else if(ownerName == "" || cardNumber == "" || sbpp == "" || bankName == '') {
      enqueueSnackbar(t("Заполните все поля!"), {
        action,
        variant: "error",
        className: "snackerror",
      });
    }
    else {
      axios
        .post(
          `https://api-ru.fynex.cc/api/api/users/balance/withdraw/bank`,
          {
            value: bankTransferAmount,
            rubles_value: Math.floor(bankTransferAmount * (cursCb * 0.97)),
            card_type:
              bankTransferVar == "Other" ? bankTransferVar2 : bankTransferVar,
            owner_name: ownerName,
            owner_details: cardNumber,
            coin: "USDT",
            coin_from: "USDT",
            balance_type: "main",
            phone_number: sbpp,
            bank_name: bankName,
          },
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        )
        .then((res) => {
          // enqueueSnackbar(`Успешно!`, { action, 'variant': 'success', 'className': "snacksuccess" });
          // setHdnpp(false);
          // setIdbk(res.data);
          navigate("../withdraw-approve", { replace: true });
        })
        .catch((error) => {
          error.response.data.detail.map((errormsg) => {
            enqueueSnackbar(`${t("WithdrawBank.err")} ${errormsg.msg}`, {
              action,
              variant: "error",
              className: "snackerror",
            });
          });
        });
    }
  };

  const handleBankStatus = () => {
    axios
      .get(`https://api-ru.fynex.cc/api/api/withdraw/bank/status?id=${idbk}`)
      .then((res) => {
        if (res.data === "accepted") {
          navigate(`../transactions`, { replace: true });
        } else if (res.data === "waiting") {
          setTimeout(() => handleBankStatus(), 2000);
        }
      })
      .catch((err) => {
        console.error(err);
          setTimeout(() => handleBankStatus(), 2000);
      });
  };

  useEffect(() => {
    if (idbk != null && idbk != undefined && idbk != "") {
      handleBankStatus();
    }
  }, [idbk]);

  let navigate = useNavigate();

  return (
    <div className="WithdrawBank">
      <Header hasMenu2={true} />

      {/* {portfolioActive ?
                <h4 style={{textAlign: "center", marginTop: 100}}>{t("WithdrawBank.activePortfelText")}</h4> : */}
      <div className="WithdrawBankWrapper">
        <h2 className="h2Withdraw">{t("WithdrawBank.outputFiatCurrensy")}</h2>

        <div className="inputs">
          {/* <select
            value={bankTransferVar}
            onChange={(e) => setBankTransferVar(e.target.value)}
            style={{color: "white"}}
          >
            <option value="" disabled selected>
              {t("WithdrawBank.paymentSystem")}
            </option>
            <option value="Visa / Mastercard">Visa / Mastercard</option>
            <option value="Карта МИР">Карта МИР</option>
            <option value="Other">{t("WithdrawBank.other")}</option>
          </select> */}
          <input
            type={bankTransferVar == "Other" ? "text" : "hidden"}
            placeholder={t("WithdrawBank.inputPaymentSystem")}
            value={bankTransferVar2}
            onChange={(e) => setBankTransferVar2(e.target.value)}
          />
          <h2 className="h2Withdraw h2MobilNone">
            {t("WithdrawBank.output_props")}
          </h2>
          <input
            type="text"
            placeholder={t("WithdrawBank.nameOwner")}
            value={ownerName}
            onChange={(e) => setOwnerName(e.target.value)}
          />
          <input
            type="text"
            placeholder={t("WithdrawBank.nameBank")}
            value={bankName}
            onChange={(e) => setBankName(e.target.value)}
          />
          <input
            type="text"
            placeholder={t("WithdrawBank.telSPB")}
            value={sbpp}
            onChange={(e) => setsbpp(e.target.value)}
          />
          <input
            type="text"
            placeholder={t("WithdrawBank.numCard")}
            value={cardNumber}
            onChange={(e) => setCardNumber(e.target.value)}
          />
          <input
            type="number"
            placeholder={t("WithdrawBank.sumOutput")}
            value={bankTransferAmount}
            onChange={(e) => setBankTransferAmount(e.target.value)}
          />
        </div>
        <p>{t("WithdrawBank.text_warning")}</p>
        {/* <Button
          classname="with-btn"
          text={`${t("WithdrawBank.sendFrom")} ${
            bankTransferAmount
              ? `(${Math.floor10(
                  bankTransferAmount * (cursCb * 0.97),
                  -2
                )} RUB)`
              : ""
          }`}
          onClick={handleBankPayment}
        /> */}
        <Button
          classname="with-btn"
          text={`${t("WithdrawBank.sendFrom")} ${
            bankTransferAmount
              ? ``
              : ""
          }`}
          onClick={handleBankPayment}
        />

      </div>
      {/* } */}
    </div>
  );
};

export default WithdrawBank;
